import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"

import { TwoColumn, transformLinkUri } from "gatsby-theme-gba"

const TwoColsEditable = ({ blok }) => {
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  }

  const replaceAll = (str, term, replacement) =>
    str.replace(new RegExp(escapeRegExp(term), "g"), replacement)

  const flatten = (text, child) => {
    return typeof child === "string"
      ? text + child
      : React.Children.toArray(child.props.children).reduce(flatten, text)
  }

  const HeadingRenderer = (props) => {
    const children = React.Children.toArray(props.children)
    const text = children.reduce(flatten, "")
    const slug = text.toLowerCase().replace(/\W/g, "-")
    return React.createElement("h" + props.level, { id: slug }, props.children)
  }

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <TwoColumn
        headline={blok.headline}
        headlineName={blok.headlineName}
        headlinePadding={blok.headlinePadding}
        left={
          <Markdown
            renderers={{ heading: HeadingRenderer }}
            transformLinkUri={(uri) => {
              return transformLinkUri(uri, "", blok.currentLanguage)
            }}
          >
            {replaceAll(blok.left, "\u2028", "")}
          </Markdown>
        }
        right={
          <Markdown
            renderers={{ heading: HeadingRenderer }}
            transformLinkUri={(uri) => {
              return transformLinkUri(uri, "", blok.currentLanguage)
            }}
          >
            {replaceAll(blok.right, "\u2028", "")}
          </Markdown>
        }
        mobileLeftBackground={blok.mobileLeftBackground}
        mobileRightBackground={blok.mobileRightBackground}
      />
    </div>
  )
}

export default TwoColsEditable
